import axios from "axios";
import { Button } from "@mui/material";
import withToast from "../hocs/withToast";
import DownloadIcon from '@mui/icons-material/Download';
import { URL as URLConfig } from "../configs/config";

function DownloadAGP(props) {
  const downloadPdf = async () => {
    props.notify("Hold on Lifeleaf has started building AGP report", "warning");

    const now = new Date();
    const offsetMinutes = now.getTimezoneOffset();
    const offsetHours = -offsetMinutes / 60;

    try {
      const res = await axios.post(
        URLConfig[URLConfig.currentENV].downloadAgpReport,
        { patientId: props.patientId, offsetHours },
        {
          responseType: "json", // because API is returning JSON
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (res.data.statusCode === 500) {
        const body = JSON.parse(res.data.body) || {};
        console.error("Error downloading PDF:", body.error || "Unknown error");
        props.notify(body.error, "error");
        return;
      }
      else {
        props.notify("AGP report downloaded successfully", "success");
      }

      const byteArray = new Uint8Array(Object.values(res.data.body));
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "agp-report.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error downloading PDF:", err);
    }
  };

  return (
    <Button
      variant="text"
      onClick={downloadPdf}
      color="success"
      className="d-flex flex-column"
      style={{width: 10, fontSize: '10px', minWidth: 10}}
      title="Ambulatory Glucose Profile"
    >
      <DownloadIcon />
      AGP
    </Button>
  );
};

export default withToast(DownloadAGP);
